import { render, staticRenderFns } from "./AdminDeleteItem.vue?vue&type=template&id=45a89e6b&scoped=true&"
import script from "./AdminDeleteItem.vue?vue&type=script&lang=js&"
export * from "./AdminDeleteItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeleteItem.vue?vue&type=style&index=0&id=45a89e6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a89e6b",
  null
  
)

export default component.exports